import React, { forwardRef } from 'react';
import clsx from 'clsx';

/* eslint-disable-next-line */
export interface IPanelBodyProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {}

export const PanelBody: React.FC<IPanelBodyProps> = forwardRef<HTMLDivElement, IPanelBodyProps>(
    (props, ref): JSX.Element => {
        const {
            className,
            ...otherProps
        } = props;

        return (
            <div
                ref={ref}
                className={clsx('oms-panel__body', className)}
                {...otherProps}
            />
        );
    }
);
